import { Box, Typography } from '@mui/material'

import MerchantBadge from 'components/MerchantBadge'

import { theme } from 'styles/theme'

import { useDetailCompany } from './useDetailCompany'

/**
 * SC-10999: linha "Empresa" (rótulo, pontilhado, valor) dos detalhes que usam
 * esse formato (nota fiscal, parcelamento, negativação). Só aparece na visão
 * multi-empresas.
 */
type DetailCompanyRowProps = {
  recordUuid?: string | null
  // Margem das linhas vizinhas, que muda de um detalhe para outro
  margin?: string
}

const DetailCompanyRow = ({ recordUuid, margin }: DetailCompanyRowProps) => {
  const merchant = useDetailCompany(recordUuid)

  if (!merchant) return null

  return (
    <Box display="flex" gap={1.25} alignItems="end" margin={margin}>
      <Typography variant="smLight" color={theme.palette.neutral[400]}>
        Empresa
      </Typography>
      <Box flexGrow={1} borderTop="0.5px dashed #CBCBCB" mb="5px" />
      <MerchantBadge
        name={merchant.name}
        logoUrl={merchant.logo_url}
        size={20}
        variant="smBold"
      />
    </Box>
  )
}

export default DetailCompanyRow
